import { render, staticRenderFns } from "./addPunishDialog.vue?vue&type=template&id=07d89e78&scoped=true"
import script from "./addPunishDialog.vue?vue&type=script&lang=js"
export * from "./addPunishDialog.vue?vue&type=script&lang=js"
import style0 from "./addPunishDialog.vue?vue&type=style&index=0&id=07d89e78&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07d89e78",
  null
  
)

export default component.exports